import { render, staticRenderFns } from "./ItemArea.vue?vue&type=template&id=05d8c404&"
import script from "./ItemArea.vue?vue&type=script&lang=js&"
export * from "./ItemArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports